export const payment = {
  field: {
    date: 'Дата',
    amount: 'Сумма',
    system: 'Платежная система',
    status: 'Статус',
    type: 'Тип платежа'
  },

  update_message:
    'Раздел обновляется и появится позже. Актуальные тарифы можно запросить у отдела технической поддержки.',

  status: {
    new: 'Новый',
    success: 'Выполнено',
    failed: 'Неуспешно',
    failed_mc: 'Неуспешно',
    frozen: 'Заморожено'
  },

  titles: {
    operation_history: 'История операций',
    top_up: 'Пополнить',
    methods: 'Cпособы оплаты'
  },
  errors: {
    email: 'Некоторые email не были добавлены'
  },

  payment_system: {
    yoomoney: 'ЮMoney',
    pay_pal: 'PayPal',
    webmoney: 'WebMoney',
    capitalist: 'Capitalist',
    bank_card: 'Банковская карта',
    internal: 'Пополнение по счету',
    zorra: 'Zorra'
  },

  payment_type: {
    a_number_subscription_fee: 'Ежемесячное списание за использование номера {number}',
    a_number_connection_cost: 'Списание за подключение номера {number}',
    referral_reward: 'Пополнение по реферальной программе',
    pbx: 'Ежемесячное списание за использование пакета АТС {package_name}',
    sms_number_verification: 'SMS-верификация',
    voice_number_verification: 'Верификация по аудио-коду',
    phone_number_verification: 'Верификация по последним цифрам номера',
    call_number_verification: 'Верификация по входящему вызову',
    balance_refill: ' Пополнение баланса',
    common: '',
    a_number: 'Ежемесячное списание за использование номера',
    mailing_sender: 'Списание за использование сендера',
    hlr: 'HLR'
  }
};
